import type { PlatzhalterWerte } from '../aktionen/platzhalter';
import type { Kandidat } from './typen';
import { briefAnrede } from '../dokumente/briefDaten';

/**
 * Was die Platzhalter-Leiste im Assistenten anbietet. Die Liste ist zugleich der
 * Vertrag: baueWerte MUSS zu jedem Eintrag einen Wert liefern, sonst ersetzt
 * ersetzePlatzhalter ihn still durch Leerstring und niemand merkt es (ein Test
 * haelt das fest).
 */
export const VERFUEGBARE_PLATZHALTER: { schluessel: string; beschreibung: string }[] = [
  { schluessel: 'empfaenger.briefanrede', beschreibung: 'Briefanrede („Sehr geehrte Frau Berg,“)' },
  { schluessel: 'empfaenger.name', beschreibung: 'Name des Empfängers' },
  { schluessel: 'empfaenger.email', beschreibung: 'E-Mail-Adresse des Empfängers' },
  { schluessel: 'empfaenger.strasse', beschreibung: 'Straße des Empfängers' },
  { schluessel: 'empfaenger.plz', beschreibung: 'PLZ des Empfängers' },
  { schluessel: 'empfaenger.stadt', beschreibung: 'Ort des Empfängers' },
  { schluessel: 'empfaenger.einheit', beschreibung: 'Einheit des Empfängers' },
  { schluessel: 'objekt.bezeichnung', beschreibung: 'Objekt' },
  { schluessel: 'absender.name', beschreibung: 'Absender' },
  { schluessel: 'absender.email', beschreibung: 'Absenderadresse' },
  { schluessel: 'datum.heute', beschreibung: 'Heutiges Datum' },
];

/**
 * Die Werte fuer EINEN Empfaenger. Angelehnt an bauePlatzhalterWerte in
 * lib/aktionen/kontext.ts — bewusst eigene Schluessel mit dem Praefix „empfaenger",
 * weil hier Mieter UND Eigentuemer durchlaufen und „mieter.nachname" bei einem
 * Eigentuemer schlicht falsch waere.
 *
 * Fehlende Werte werden zu '', nie zu undefined: der Resolver wuerde daraus sonst
 * „undefined" im Mailtext machen.
 */
export function baueWerte(
  kandidat: Kandidat,
  absender: { name: string; email: string },
  heute: string,
): PlatzhalterWerte {
  return {
    // Ohne Anrede/Nachname (Firma, Dienstleister) neutral: „Sehr geehrte Damen und Herren,“
    'empfaenger.briefanrede': briefAnrede({ anrede: kandidat.anrede, nachname: kandidat.nachname }),
    'empfaenger.name': kandidat.name || '',
    'empfaenger.email': kandidat.email || '',
    // Die Anschrift des Empfaengers — bei Eigentuemern seine eigene, bei Mietern die des
    // Objekts, in dem er wohnt (Mieter haben in der Datenbank keine eigene Anschrift).
    // Strasse und Hausnummer zusammen, weil sie im Brief in einer Zeile stehen.
    'empfaenger.strasse': [kandidat.strasse, kandidat.hausnummer].filter(Boolean).join(' '),
    'empfaenger.plz': kandidat.plz || '',
    // Schluessel wie die Quellspalte: die Tabellen fuehren `stadt`, nicht `ort`.
    'empfaenger.stadt': kandidat.stadt || '',
    'empfaenger.einheit': kandidat.einheit_bezeichnung || '',
    'objekt.bezeichnung': kandidat.objekt_bezeichnung || '',
    'absender.name': absender?.name || '',
    'absender.email': absender?.email || '',
    'datum.heute': heute || '',
  };
}
